module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon6.2e1dd551.png";